module.exports = "pegasus_template/assets/tech/safari/107.png";